export const logoutHandler = async (): Promise<boolean> => {
  window.location.assign('/login')
  return true
}
